import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsImgurComponent } from './simple-icons-imgur.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsImgurComponent ],
    exports:      [ SimpleIconsImgurComponent ],
    bootstrap:    []
})
export class SimpleIconsImgurModule {}
